import { render, staticRenderFns } from "./overdue-commit.vue?vue&type=template&id=d2e47252"
import script from "./overdue-commit.vue?vue&type=script&lang=tsx"
export * from "./overdue-commit.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports